// extracted by mini-css-extract-plugin
export default {"container":"blog_container__kZE5g","mainTitle":"blog_mainTitle__-jbUA","blogPostMarginDivider":"blog_blogPostMarginDivider__zrhCt"};